export const EDIS_HOLDINGS_DATA = "EDIS_HOLDINGS_DATA";
export const EDIS_HOLDINGS_START_LOADER = "EDIS_HOLDINGS_START_LOADER";
export const EDIS_HOLDINGS_STOP_LOADER = "EDIS_HOLDINGS_STOP_LOADER";
export const EDIS_HOLDINGS_HIDE_ERROR = "EDIS_HOLDINGS_HIDE_ERROR";
export const EDIS_HOLDINGS_ERROR = "EDIS_HOLDINGS_ERROR";
